export var AppMode;
(function (AppMode) {
    AppMode["DEFAULT"] = "default";
    AppMode["DEMO"] = "demo";
    AppMode["PR"] = "pr";
    AppMode["CLOUD_BETA"] = "cloud_beta";
    AppMode["DEV"] = "development";
})(AppMode || (AppMode = {}));
//# sourceMappingURL=constants.js.map